module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./CheckOrderView.js"));
	}, "GiftCheckOrderView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GiftCheckOrderView!./src/pages/Shop/GiftCheckOrder/CheckOrderView.js
// module id = 1786
// module chunks = 367